import { Helmet } from 'react-helmet-async';

/** GA4 리포트에서 페이지별로 구분되도록 라우트마다 브라우저 탭 제목을 부여하는 공용 컴포넌트 */
export function PageTitle({ title }: { title: string }) {
  return (
    <Helmet>
      <title>{title} - ALT Generation</title>
    </Helmet>
  );
}
